import MoneyInput from 'components/MoneyInput';
import React from 'react';
import { Box } from '@mui/material';
import { formatInheritedCents } from 'utils/rateSettings/SharedRateSettingsForm.utils';
import { useResourceContext } from 'react-admin';
import { useFormContext } from 'react-hook-form';
import { useRateControllerContext } from '../rateController/RateControllerContext';
import { codeToField } from '../rateController/rateControllerModel';
import { RateFieldCheckbox } from './RateFieldCheckbox';

type Props = { source: string; inheritedSettings?: any };

export const ChargeRateCentsInput = ({ source, inheritedSettings = {} }: Props) => {
  const resource = useResourceContext();
  const { getValues } = useFormContext();

  const { isControlled } = useRateControllerContext();
  const isLocationLevel =
    resource === 'LocationPositionRateSetting' || resource === 'AgencyLocationPositionRateSetting';
  const label = isLocationLevel ? 'Location Rate' : '8hr Charge Rate';

  return (
    <Box display="flex" alignItems="center" gap={1}>
      <MoneyInput
        source={codeToField('chargeRate', source, getValues)}
        label={label}
        disabled={!isControlled('chargeRate')}
        sx={{ flex: 1 }}
        helperText={formatInheritedCents(inheritedSettings, 'charge_rate_cents')}
      />
      <RateFieldCheckbox code="chargeRate" label="Admin controls Location Rate" />
    </Box>
  );
};
